/* Theme-Manager — Dark / Light / System.
   Speichert User-Wahl in localStorage, appliciert das resolved theme via [data-theme] auf <html>.
   System-Mode hört auf prefers-color-scheme. Default ist 'system'. */

const KEY = 'urs-desktop-theme';

export function getTheme() {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'light' || v === 'dark' || v === 'system') return v;
  } catch {}
  return 'system';
}

export function setTheme(theme) {
  try { localStorage.setItem(KEY, theme); } catch {}
  applyTheme(theme);
}

function resolve(theme) {
  if (theme === 'light' || theme === 'dark') return theme;
  if (typeof window !== 'undefined' && window.matchMedia('(prefers-color-scheme: dark)').matches) return 'dark';
  return 'light';
}

export function applyTheme(theme = getTheme()) {
  const resolved = resolve(theme);
  document.documentElement.setAttribute('data-theme', resolved);
}

export function subscribeSystemTheme(handler) {
  const mq = window.matchMedia('(prefers-color-scheme: dark)');
  const cb = () => { if (getTheme() === 'system') handler(); };
  mq.addEventListener?.('change', cb);
  return () => mq.removeEventListener?.('change', cb);
}
